import { render } from "./post-smtp-notice.vue?vue&type=template&id=d473dc1c&scoped=true"
import script from "./post-smtp-notice.vue?vue&type=script&lang=js"
export * from "./post-smtp-notice.vue?vue&type=script&lang=js"

import "./post-smtp-notice.vue?vue&type=style&index=0&id=d473dc1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d473dc1c"]])

export default __exports__